{
    "BsoAttachmentsElement": {
        "title": "Attachments Upload"
    },
    "mask": {
        "BsoAttachmentsElement": {
            "groupTitle": "Upload",
            "showError": "Show Error",
            "bsoOrigin": "Origin",
            "bsoCategory": "Category",
            "accept": "Accept",
            "acceptPlaceholder": "e.g. .doc,.docx,application/msword",
            "multiple": "Allow Multiple",
            "renderAsList": "Display as List of Inputs",
            "validationMaxAttachmentSize": "Max Filesize (MB)",
            "validationMaxAttachments": "Max Number of Files",
            "attachmentInputListSettings": "Upload Item Settings",
            "required": "Required"
        }
    }
}